<template>
  <div>
    <div class="ts-flex ts-justify-between">
      <div>
        <a-range-picker
          v-model="dateRange"
          :allowClear="false"
          format="DD-MM-YYYY"
          valueFormat="DD-MM-YYYY"
          style="width:200px"
          v-tooltip="$t('stockConfirm.stockInDate')"
          @change="fetchData()"
        />
      </div>
      <div class=" ts-flex ts-space-x-3">
        <a-select
          v-model="status"
          mode="multiple"
          @change="fetchData()"
          :maxTagCount="1"
          style="width:200px"
        >
          <a-select-option :value="0">Pendding</a-select-option>
          <a-select-option :value="1">Confirmed</a-select-option>
        </a-select>
        <ts-input
          v-model="search"
          v-tooltip="$t('stockConfirm.search')"
          :placeholder="$t('search')"
          style="width: 250px;"
          class="inline-block"
        />
        <ts-filter ref="filter">
          <div class="row">
            <div class="col-md-12">
              <label>{{ $t('stockConfirm.warehouse') }}</label>
              <ts-location-filter
                :isDefaultSelect="false"
                :showPlaceholder="false"
                @filter="locationFilter"
              ></ts-location-filter>
            </div>
          </div>
        </ts-filter>
      </div>
    </div>
    <div class="overflow-auto ts-mt-3">
      <Table
        :data="resources"
        :columns="columns"
        size="small"
        highlight-row
        stripe
        max-height="700"
        :loading="loading"
      >
        <template slot-scope="{ row }" slot="branchNameEn">
          {{ row.branch.branch_name_en }}
        </template>
        <template slot-scope="{ row }" slot="poNumber">
          {{ row.purchase_order ? row.purchase_order.po_number : null }}
        </template>
        <template slot-scope="{ row }" slot="vendorNamr">
          {{ row.supplier ? row.supplier.vendor_name : null }}
        </template>
        <template slot-scope="{ row }" slot="locationName">
          {{ row.location.location_name_en }}
        </template>
        <template slot-scope="{ row }" slot="remarks">
          <span class="badge badge-default" v-if="row.is_confirm_stock"
            >Confirmed</span
          >
          <span class="badge badge-info" v-else>Pendding</span>
        </template>
        <template slot-scope="{ row }" slot="comfirmedBy">
          {{ row.comfirmed_by ? row.comfirmed_by.name : null }}
        </template>
        <template slot-scope="{ row }" slot="action">
          <a
            href="#"
            v-tooltip="$t('view')"
            class="text-primary mr-2"
            @click.prevent="onView(row)"
          >
            <i class="fas fa-eye"></i>
          </a>
          <!-- Need in Msk -->
          <a
            href="#"
            v-tooltip="$t('edit')"
            class="text-primary"
            @click.prevent="onEdit(row)"
            v-if="row.is_confirm_stock"
          >
            <i class="fas fa-edit"></i>
          </a>
          <!--  -->
        </template>
      </Table>
    </div>
    <div class="d-flex justify-content-between align-items-center p-15">
      <ts-total-list v-model="pagination" />
      <ts-pagination v-model="pagination" @navigate="fetchData">
      </ts-pagination>
    </div>
  </div>
</template>
<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import moment from 'moment'
export default {
  name: 'stockInList',
  data() {
    return {
      loading: false
    }
  },
  created() {
    this.$store.state.stock.stockInConfirm.dateRange = [
      moment()
        .startOf('M')
        .format('DD-MM-YYYY'),
      moment()
        .endOf('M')
        .format('DD-MM-YYYY')
    ]
    this.fetchData()
  },
  computed: {
    ...mapState('stock/stockInConfirm', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.stock.stockInConfirm.search
      },
      set(newValue) {
        this.$store.commit('stock/stockInConfirm/SET_SEARCH', newValue)
        this.$store.commit('stock/stockInConfirm/RESET_CURRENT_PAGE')
      }
    },
    status: {
      get() {
        return this.$store.state.stock.stockInConfirm.is_confirm
      },
      set(newValue) {
        this.$store.commit('stock/stockInConfirm/SET_STATUS', newValue)
      }
    },
    dateRange: {
      get() {
        return this.$store.state.stock.stockInConfirm.dateRange
      },
      set(newValue) {
        this.$store.commit('stock/stockInConfirm/SET_DATE_RANGE', newValue)
      }
    },
    columns() {
      return [
        {
          title: this.$t('stockConfirm.branch'),
          width: 120,
          slot: 'branchNameEn'
        },
        {
          title: this.$t('stockConfirm.stockInDate'),
          width: 130,
          key: 'stock_in_date'
        },
        {
          title: this.$t('stockConfirm.stockInNumber'),
          width: 160,
          key: 'stock_in_number'
        },
        {
          title: this.$t('stockConfirm.poNumber'),
          minWidth: 200,
          slot: 'poNumber'
        },
        {
          title: this.$t('stockConfirm.referenceInvoice'),
          minWidth: 200,
          key: 'invoice_no'
        },
        {
          title: this.$t('stockConfirm.supplier/vendor'),
          minWidth: 240,
          slot: 'vendorNamr'
        },
        {
          title: this.$t('stockConfirm.warehouse'),
          slot: 'locationName',
          minWidth: 200
        },
        {
          title: this.$t('stockConfirm.status'),
          slot: 'remarks',
          minWidth: 130,
          align: 'center'
        },
        {
          title: this.$t('stockConfirm.confirmDate'),
          key: 'confirmed_date',
          minWidth: 180,
          align: 'center'
        },
        {
          title: this.$t('stockConfirm.confirmBy'),
          slot: 'comfirmedBy',
          width: 200
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 94
        }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('stock/stockInConfirm/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    onView(record) {
      this.$store.commit('stock/stockInConfirm/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'stock-confirm-stock-in',
        params: { id: record.stock_in_id }
      })
    },
    locationFilter(value) {
      this.$store.commit('stock/stockInConfirm/SET_LOCATION_ID', value)
      this.fetchData()
    },
    branchFilter(value) {
      this.$store.commit('stock/stockInConfirm/SET_BRANCH_ID', value)
      this.fetchData()
    },
    onEdit(record) {
      this.$router.push({
        name: 'stock-confirm-edit-serial',
        params: { stockId: record.stock_in_id }
      })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData()
    }, 500)
  }
}
</script>
